"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var createArrayProxy_1 = require("../Store/createArrayProxy");
var createObjectProxy_1 = require("../Store/createObjectProxy");
/**
 * Adds proxies to the proxy tree as new object or array
 * members are discovered on a dynamic object proxy.
 *
 * This is split out from the `duckPatchDynamicObject()`
 * utility to avoid unnecessary argument polution, as this
 * process currently depends upon access to the store and
 * proxies tree.
 */
var createDynamicObjectMemberProxy = function (store, proxies, path, key, addedValue, injectedCreateArrayProxy, injectedCreateObjectProxy) {
    if (injectedCreateArrayProxy === void 0) { injectedCreateArrayProxy = createArrayProxy_1.default; }
    if (injectedCreateObjectProxy === void 0) { injectedCreateObjectProxy = createObjectProxy_1.default; }
    var targetPath = __spreadArrays(path, [key]);
    var newProxyNode = Array.isArray(addedValue)
        ? injectedCreateArrayProxy(store, addedValue, targetPath)
        : injectedCreateObjectProxy(store, addedValue, targetPath);
    proxies.proxy[key] = newProxyNode.proxy;
    proxies.children[key] = newProxyNode;
};
exports.default = createDynamicObjectMemberProxy;
//# sourceMappingURL=createDynamicObjectMemberProxy.js.map